var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4"},[_c('v-card-title',[_vm._v("Configuração do SubProduto "+_vm._s(_vm.subProduto.descricao))]),_c('v-divider',{staticClass:"my-4"}),_c('config-sub-produto-edit',{attrs:{"subProduto":_vm.subProduto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }